export const UPDATE_PRODUCER				 = 'UPDATE_PRODUCER'
export const UPDATE_PRODUCER_SUCCESS = 'UPDATE_PRODUCER_SUCCESS'
export const UPDATE_PRODUCER_FAIL	   = 'UPDATE_PRODUCER_FAIL'